import {useTranslation} from 'react-i18next'

import BottomSheetPicker from '@progyny/components/Navigation/BottomSheetPicker'
import {MeQuery} from '@progyny/generated/graphql'

type LanguagePickerSheetProps = {
  open: boolean
  onClose: () => void
  languages?: MeQuery['languages']
  selectedCode: string
  onSelect: (code: string) => void
}

const LanguagePickerSheet = ({
  open,
  onClose,
  languages,
  selectedCode,
  onSelect,
}: LanguagePickerSheetProps) => {
  const {t} = useTranslation()

  return (
    <BottomSheetPicker
      open={open}
      onClose={onClose}
      title={t('mobile_nav_language_picker_title')}
      items={(languages ?? []).map((lang) => ({
        key: lang?.code ?? '',
        label: lang?.name,
        selected: lang?.code === selectedCode,
      }))}
      onSelect={onSelect}
    />
  )
}

export default LanguagePickerSheet
